// Formata números de telefone brasileiros para exibição.
//   554188977954  -> +55 (41) 8897-7954
//   5541988977954 -> +55 (41) 98897-7954
//   41988977954   -> (41) 98897-7954
// Qualquer outro formato (estrangeiro, ID de grupo etc.) é devolvido sem alteração.
const formatPhone = (number) => {
  if (!number) return "";
  const raw = String(number);
  const digits = raw.replace(/\D/g, "");

  const formatLocal = (local) =>
    local.length === 11
      ? local.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
      : local.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");

  if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
    return `+55 ${formatLocal(digits.slice(2))}`;
  }
  if (digits.length === 10 || digits.length === 11) {
    return formatLocal(digits);
  }
  return raw;
};

export default formatPhone;
